import { useQuery } from '@tanstack/react-query';

import { courseConst, ICategoryCourses } from 'modules/courses';
import { $apiV2 } from 'modules/global';

export const getCategoryCourses = () => async () => {
  const { data } = await $apiV2.get(`/teacher-course/category-courses`);

  return { categoryCourses: data?.data };
};

export const useCategoryCourses = () => {
  const { data, ...args } = useQuery<{ categoryCourses: ICategoryCourses[] }>({
    queryKey: [courseConst.queryKeys.CATEGORY_COURSES],
    queryFn: getCategoryCourses()
  });

  return { ...data, ...args };
};
